import { Email, EmailSummary } from "features/Resources/Email/models";
import { Meeting, MeetingSummary } from "features/Resources/Meeting/models";
import { Message, MessageSummary } from "features/Resources/Message/models";
import { Task, TaskId, TaskSummary } from "features/Resources/Task/models";
import { StageKey } from "features/Stage/constants";

export type ActionV2 = Email | Message | Task | Meeting;

export type PrefixId = Email["prefixId"] | Message["prefixId"] | Meeting["prefixId"];

export const ACTION_TYPES = ["task", "email", "message", "meeting", "checkpoint"] as const;
export type ActionType = (typeof ACTION_TYPES)[number];
export type OptionalActionType = ActionType | undefined | "";

export type TemplateType =
  | "email_template"
  | "message_template"
  | "task_template"
  | "meeting_template"
  | "checkpoint_template";

export type ActionSummaryData = EmailSummary | MessageSummary | TaskSummary | MeetingSummary;

type ActionSummaryCommon = {
  unifiedDate: Date | undefined;
  unifiedDependencyId: TaskId | undefined;
  unifiedIsImmediate: boolean;
  prefixId: string;
};

export type EmailActionSummary = ActionSummaryCommon & {
  actionType: "email";
  action: EmailSummary;
  stageKey: StageKey;
};

export type MeetingActionSummary = ActionSummaryCommon & {
  actionType: "meeting";
  action: MeetingSummary;
  stageKey: StageKey;
};

export type MessageActionSummary = ActionSummaryCommon & {
  actionType: "message";
  action: MessageSummary;
  stageKey: StageKey;
};

export type TaskActionSummary = ActionSummaryCommon & {
  actionType: "task";
  action: TaskSummary;
  stageKey: StageKey;
};

export type CheckpointActionSummary = ActionSummaryCommon & {
  actionType: "checkpoint";
  action: any;
  stageKey: StageKey;
};

export type ActionSummary =
  | EmailActionSummary
  | MessageActionSummary
  | TaskActionSummary
  | MeetingActionSummary
  | CheckpointActionSummary;
